import React from "react";
import { Link } from "react-router-dom";
import "./GalleryOverviewPage.css";

const GalleryOverviewPage = () => {
  return (
    <div className="gallery-overview-wrapper">
      <div className="gallery-overview-container">
        <div className="gallery-options-grid">
          <div className="gallery-option-card">
            <div className="option-card-content">
              <h2 className="option-title">ColorFuel Originals</h2>
              <p className="option-description">
                Browse our curated collections of original ColorFuel Ethereum NFTs from OpenSea.
              </p>
              <Link to="/discover/ethereum" className="option-button">
                VIEW GALLERY
              </Link>
              <div className="card-footer-line"></div>
            </div>
          </div>

          <div className="gallery-option-card disabled">
            <div className="option-card-content">
              <h2 className="option-title">Explore Artists</h2>
              <p className="option-description">
                Discover talented artists and explore their unique digital artworks on ColorFuel Solana.
              </p>
              <button 
                className="option-button disabled" 
                disabled
              >
                COMING SOON
              </button>
              <div className="card-footer-line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryOverviewPage;
